import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../../comun/services/api/auth.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
	selector: 'app-auto-login',
	standalone: true,
	imports: [CommonModule],
	templateUrl: './auto-login.component.html',
	styleUrls: ['./auto-login.component.scss']
})
export class AutoLoginComponent implements OnInit {

	constructor(
		private authService: AuthService,
		private route: Router,
		private rutaActiva: ActivatedRoute,
		private translateService: TranslateService
	) { }

	ngOnInit(): void {
		const token = this.rutaActiva.snapshot.params.token;

		this.authService.autologin(token).subscribe({
			next: (auth) => {
				if (auth.user_info.idioma){
					this.translateService.use(auth.user_info.idioma.toLowerCase());
				}
				this.navegarAutologin(auth.destino);
			},
			error: () => {
				this.route.navigate(['/error']);
				new Error('Usuario o contraseña incorrectos');
			}
		});
	}

	private navegarAutologin(destino: string | undefined): void {
		if (!destino) return;

		while (destino.indexOf('_PRM_') !== -1) {
			destino = destino.replace('_PRM_', '/');
		}

		// Separar path y query params
		const [pathPart, queryString] = destino.split('?');
		const queryParams: any = {};

		if (queryString) {
			new URLSearchParams(queryString).forEach((v, k) => queryParams[k] = v);
		}

		// Path como array de segmentos
		const pathSegments = pathPart.split('/');
		this.route.navigate(pathSegments, { queryParams });
	}
}
